<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="资质信誉"
      third-bread="案例与新闻添加"
      first-url="/user/sign"
      second-url="/user/news"
      title-name="案例与新闻添加"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="大类">
          <el-select v-model="Alist.type" placeholder="请选择">
            <el-option
              v-for="item in Large"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主图">
          <el-upload action="/api/photo/uploadFile" :on-success="GetMainUrl">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="标题">
          <el-input
                     v-model="Alist.title" ></el-input>
        </el-form-item>
              <el-form-item label="事件时间">
                <el-date-picker
                        v-model="Alist.eventTime"
                        type="date"
                        formate="yyyy-MM-dd hh:mm:ss"
                        value-format="yyyy-MM-dd hh:mm:ss"
                        placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
        <el-form-item label="主图描述">
          <el-input  type="textarea"
                     :rows="3"
                     v-model="Alist.mainDescription" ></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <ripeav-text-input v-model="Alist.description" ></ripeav-text-input>
        </el-form-item>
        <el-form-item label="预览">
          <div v-html="Alist.description"></div>
        </el-form-item>
<!--        -->
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  import RipeavTextInput from "../../../components/tinymce/RipeavTextInput";

  export default {
    name: "NewsAdd",
    components: {RipeavTextInput, UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        Alist: {
          'type':null,
          'smallType':null,
          'title':null,
          'eventTime':'',
          'mainPhotoUrl':null,
          'mainDescription':null,
          'photoUrl':null,
          'description':null,
          'photoUrlTwo':null,
          'descriptionTwo':null,
          'photoUrlThree':null,
          'descriptionThree':null,
          'photoUrlFour':null,
          'descriptionFour':null,
          'photoUlrFive':null,
          'descriptionFive':null,

        },//表示Add添加的数据
      }
    },
    created() {
      this.GetLarge()
    },
    watch:{
      'Alist.type'(code){
        console.log(code)
        if(code == 1){
          this.GetSmallFirst()
        }
        if(code == 2){
          this.GetSmallSecond()
        }
      }
    },
    methods:{
      GetMainUrl(file){
        this.Alist.mainPhotoUrl=file.data;
      },
      GetfirstUrl(){
        this.Alist.photoUrl=file.data;
      },
      GetsecondUrl(){
        this.Alist.photoUrlTwo=file.data;
      },
      GetthirdUrl(){
        this.Alist.photoUrlThree=file.data;
      },
      GetfourUrl(){
        this.Alist.photoUrlFour=file.data;
      },
      GetfiveUrl(){
        this.Alist.photoUlrFive=file.data;
      },
      GetLarge(){
        this.$axios.get('/api/case/getTypeList').then(res=>{
          this.Large=res.data.data;
        })
      },
      GetSmallFirst(){
        this.$axios.get('/api/case/getCaseTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      GetSmallSecond(){
        this.$axios.get('/api/case/getJournalismTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      handleAdd(){
        this.$axios.post('/api/case/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>